export default __webpack_public_path__ + "static/small-business-accomplishment-2c-ee69bb6e1f53158fe208eea2881b672f.webp";